import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

// Services
import { HeaderService } from 'src/app/services/header/header.service';
import { AmplitudeService } from 'src/app/services/amplitude.service';
import { EditShoppingCarService } from 'src/app/services/header/edit-shopping-car/edit-shopping-car.service';

// Models
import { ProductShoppingCar } from 'src/app/models/productShoppingCar';

@Component({
    selector: 'app-shopping-car',
    templateUrl: './shopping-car.component.html',
    styleUrls: ['./shopping-car.component.sass'],
    standalone: false
})
export class ShoppingCarComponent implements OnInit {

  listSubcriptions: Subscription[] = [];

  listProductShoppingCar: ProductShoppingCar[] = [];

  statusCard: number = 1; // 1-cargando, 2-listado, 3-sin contenido

  showShoppingCar: boolean = false;

  total:  number = 0;

  tryDeleteOrder: boolean = false;
  deletingOrder: boolean = false;

  clientId: string = '';

  constructor(
    private _headerService: HeaderService,
    private _amplitudeService: AmplitudeService,
    private _router: Router,
    private _editShoppingCarService: EditShoppingCarService,
  ) { }

  ngOnInit(): void {
    this.clientId = localStorage.getItem('clientId');
    this.listenerShowShoppingCar();
  }

  ngOnDestroy(): void {
    this.listSubcriptions.forEach((sub: Subscription) => { if (sub) sub.unsubscribe(); });
  }

  openShoppingCar(): void {
    if (!this.showShoppingCar) this.getListProductsShoppingCar();
    this.showShoppingCar = !this.showShoppingCar;
    if (this.showShoppingCar == false) this._amplitudeService.emmiterLogEvent('CLOSE_SHOPPING_CAR', {
      CLIENT_ID: this.clientId
    });
  }

  tryDeleteProduct( product: ProductShoppingCar ): void {
    this.listProductShoppingCar.map(p => p.id == product.id ? p.selected = true : p.selected = false);
    this._amplitudeService.emmiterLogEvent('TRY_DELETE_PRODUCT', {
      PRODUCT_ID: product.id,
      PRODUCT_NAME: product.name,
      PRODUCT_VALUE: product.value,
      CLIENT_ID: this.clientId
    });
  }

  cancelTryDeleteProduct( ): void {
    this.listProductShoppingCar.map(p => p.selected = false);
  }

  async getListProductsShoppingCar() {
    this.statusCard = 1;
    let response: any = await this._headerService.getListProducts().toPromise().catch((err: any) => this.handleError(err));
    if( response && response.data && response.data.items ){
      this.listProductShoppingCar = new ProductShoppingCar().mapProduct(response.data.items);
      this.total = 0;
      if(this.listProductShoppingCar.length > 0){
        this.listProductShoppingCar.map(p => this.total += p.total);
        this.statusCard = 2;
      } else this.statusCard = 3;
      this._amplitudeService.emmiterLogEvent('OPEN_SHOPPING_CAR', {
        ITEMS_LENGTH: this.listProductShoppingCar.length,
        TOTAL: this.total,
        CLIENT_ID: this.clientId
      });
    }
  }

  async deleteproduct(product: ProductShoppingCar) {

    let response: any = await this._headerService.deleteProduct(product.id).toPromise()
      .catch((err: any) => {
        this._amplitudeService.emmiterLogEvent('DELETE_PRODUCT_FAIL', {
          PRODUCT_ID: product.id,
          PRODUCT_NAME: product.name,
          PRODUCT_VALUE: product.value,
          CLIENT_ID: this.clientId
        });
        console.log('Error al eliminar producto')
      });
    if( response ){
      this.getListProductsShoppingCar();
      this._headerService.emmiterUpdateNumberOrdersAndShoppingCar(true);
      this._amplitudeService.emmiterLogEvent('DELETE_PRODUCT_OK', {
        PRODUCT_ID: product.id,
        PRODUCT_NAME: product.name,
        PRODUCT_VALUE: product.value,
        CLIENT_ID: this.clientId
      });
    }
  }

  editProduct(productId: number): void {
    this._editShoppingCarService.emmiterProductId(productId);
  }

  tryDeleteOrderF(action: boolean): void {
    this.tryDeleteOrder = action;
    if (action) this._amplitudeService.emmiterLogEvent('TRY_DELETE_ORDER', {
      CLIENT_ID: this.clientId,
      TOTAL: this.total
    });
  }

  async deleteOrder() {
    this.tryDeleteOrderF(false);
    this.deletingOrder = true;
    let response: any = await this._headerService.deleteOrder().toPromise()
      .catch((err: any) => {
        this._amplitudeService.emmiterLogEvent('DELETE_ORDER_FAIL', {
          CLIENT_ID: this.clientId,
          TOTAL: this.total
        });
        console.log('Error al eliminar la orden')
      });
    if (response) {
      this.listProductShoppingCar = [];
      this.statusCard = 1;
      this.deletingOrder = false;
      this.showShoppingCar = false;
      this._headerService.emmiterUpdateNumberOrdersAndShoppingCar(true);
      this._amplitudeService.emmiterLogEvent('DELETE_ORDER_OK', {
        CLIENT_ID: this.clientId,
        TOTAL: this.total
      });
    }
  }

  goCheckout(): void {
    this.showShoppingCar = false;
    this._amplitudeService.emmiterLogEvent('GO_CHECKOUT', {
      TOTAL: this.total,
      CLIENT_ID: this.clientId
    });
    this._router.navigate(['checkout']);
  }

  // formatCurrency(): void {
  //   this.listProductShoppingCar.map(p => {
  //     p.subtotal = Intl.NumberFormat('es-CO',{
  //       style: 'currency',
  //       currency: 'COP',
  //       minimumFractionDigits: 0
  //     }).format( parseInt(p.subtotal) ) ;
  //   });
  // }

  handleError(error: HttpErrorResponse): void {
    this.statusCard = 3;
    if(error.error.message) console.log(error.error.message);
  }

  listenerShowShoppingCar(): void {
    this.listSubcriptions.push(
      this._headerService.getSubjetShowShoppingCar().asObservable().subscribe(
        data => {
          this.openShoppingCar();
          this.showShoppingCar = data;
        }
      )
    );
  }

}
